export class ApiProcessUpdate {
  id?: string;
  inventoryKubunId?: number;
  processRemarks?: string;
  quantity?: number;
  location?: string;
  createdUserId?: string;
  updatedUserId?: string;

  constructor() {
    this.id = null;
    this.inventoryKubunId = null;
    this.processRemarks = null;
    this.quantity = null;
    this.location = null;
    this.createdUserId = null;
    this.updatedUserId = null;
  }
}
